<template>
    <div>
        <section>
            <div class="container py-4">
                <div class="box is-large">
                    <!-- <h1 class="p-2 cardHeader is-size-3">Intraday Perf.</h1> -->
                    <table class="table is-striped perfoTable">
                        <tbody>
                            <tr>
                                <td>LS M</td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.LS.ret < 0 }">{{
                                    intradayPNL.LS.ret.toFixed(2)
                                }}%</td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.LS.fin < 0 }">
                                    {{ intradayPNL.LS.fin.toLocaleString('pt-BR', moneyFmt).slice(0, -3) }}
                                </td>
                            </tr>
                            <tr>
                                <td>LB FIM</td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.LB.ret < 0 }">{{
                                    intradayPNL.LB.ret.toFixed(2)
                                }}%</td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.LB.fin < 0 }">
                                    {{ intradayPNL.LB.fin.toLocaleString('pt-BR', moneyFmt).slice(0, -3) }}
                                </td>
                            </tr>
                            <tr class="row-toggle" v-on:click="expandLO = !expandLO">
                                <td>LO FIA <span class="toggle-icon has-text-grey">{{ expandLO ? '⊖' : '⊕' }}</span></td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.LO.ret < 0 }">{{
                                    intradayPNL.LO.ret.toFixed(2)
                                }}%</td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.LO.fin < 0 }">
                                    {{ intradayPNL.LO.fin.toLocaleString('pt-BR', moneyFmt).slice(0, -3) }}
                                </td>
                            </tr>
                            <tr v-if="expandLO && Number.isFinite(intradayPNL.LO_FAT.ret) && Number.isFinite(intradayPNL.LO_ML.ret)" class="is-size-7">
                                <td></td>
                                <td>
                                    <span class="has-text-grey-light">FR </span><span v-bind:class="{ 'has-text-danger-dark': intradayPNL.LO_FAT.ret < 0 }">{{ intradayPNL.LO_FAT.ret.toFixed(2) }}%</span>
                                </td>
                                <td>
                                    <span class="has-text-grey-light">ML </span><span v-bind:class="{ 'has-text-danger-dark': intradayPNL.LO_ML.ret < 0 }">{{ intradayPNL.LO_ML.ret.toFixed(2) }}%</span>
                                </td>
                            </tr>
                            <tr class="row-toggle" v-on:click="expandGPREV = !expandGPREV">
                                <td>LO GPREV <span class="toggle-icon has-text-grey">{{ expandGPREV ? '⊖' : '⊕' }}</span></td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.LO_GPREV.ret < 0 }">{{
                                    intradayPNL.LO_GPREV.ret.toFixed(2)
                                }}%</td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.LO_GPREV.fin < 0 }">
                                    {{ intradayPNL.LO_GPREV.fin.toLocaleString('pt-BR', moneyFmt).slice(0, -3) }}
                                </td>
                            </tr>
                            <tr v-if="expandGPREV && Number.isFinite(intradayPNL.LO_GPREV_FAT.ret) && Number.isFinite(intradayPNL.LO_GPREV_ML.ret)" class="is-size-7">
                                <td></td>
                                <td>
                                    <span class="has-text-grey-light">FR </span><span v-bind:class="{ 'has-text-danger-dark': intradayPNL.LO_GPREV_FAT.ret < 0 }">{{ intradayPNL.LO_GPREV_FAT.ret.toFixed(2) }}%</span>
                                </td>
                                <td>
                                    <span class="has-text-grey-light">ML </span><span v-bind:class="{ 'has-text-danger-dark': intradayPNL.LO_GPREV_ML.ret < 0 }">{{ intradayPNL.LO_GPREV_ML.ret.toFixed(2) }}%</span>
                                </td>
                            </tr>
                            <tr>
                                <td>IBOV</td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.ibov.ret < 0 }">{{
                                    intradayPNL.ibov.ret.toFixed(2)
                                }}%</td>
                                <td v-bind:class="{ 'has-text-danger-dark': intradayPNL.ibov.ret < 0 }">
                                    {{ intradayPNL.ibov.fin.toLocaleString('pt-BR', moneyFmt).slice(3, -3) }} pts
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h4 class="has-text-right has-text-weight-light">{{ intradayPNL.datetime }}
                    </h4>

                </div>
                <div class="container">
                    <button class="button is-medium" v-on:click="this.loadRetFile();">Atualizar</button>
                </div>
            </div>
        </section>
    </div>
</template>
  
<script>
export default {
    name: "funds-intraday",
    data() {
        return {
            intradayPNL: {
                LO: { ret: undefined, fin: undefined },
                LO_GPREV: { ret: undefined, fin: undefined },
                LS: { ret: undefined, fin: undefined },
                LB: { ret: undefined, fin: undefined },
                ibov: { ret: undefined, fin: undefined },
                LO_FAT: { ret: undefined },
                LO_ML: { ret: undefined },
                LO_GPREV_FAT: { ret: undefined },
                LO_GPREV_ML: { ret: undefined },
                datetime: undefined,
            },
            expandLO: false,
            expandGPREV: false,
            preParse: [],
            moneyFmt: {
                style: 'currency',
                currency: 'BRL',
                // maximumFractionDigits: 0
            },
            timer: ''
        };
    },
    methods: {
        loadRetFile() {
            const csvUrl = process.env.VUE_APP_INTRADAY_CSV_URL || "https://mobile.bayescm.com/data/mobileIntraday.csv";
            this.$papa.parse(csvUrl + "?_=" + (new Date).getTime(), {
                header: true,
                skipEmptyLines: true,
                download: true,
                complete: (results) => {
                    // console.log("loaded");
                    this.preParse = results.data;
                    const rows = results.data || [];
                    const byName = {};
                    rows.forEach(function (row) {
                        if (row.Fundo) byName[row.Fundo.trim()] = row;
                    });
                    const getRow = function (name) {
                        return byName[name] || null;
                    };
                    const setFund = function (target, row) {
                        if (row) {
                            target.ret = parseFloat(row.Return);
                            target.fin = parseFloat(row.Value);
                        }
                    };
                    const setRet = function (target, row) {
                        if (row) target.ret = parseFloat(row.Return);
                    };
                    const ibov = getRow('IBOV');
                    setFund(this.intradayPNL.ibov, ibov);
                    setFund(this.intradayPNL.LS, getRow('LS'));
                    setFund(this.intradayPNL.LB, getRow('LB'));
                    setFund(this.intradayPNL.LO, getRow('LO'));
                    setFund(this.intradayPNL.LO_GPREV, getRow('LO_GERDAU'));
                    setRet(this.intradayPNL.LO_FAT, getRow('LO(FATORES)'));
                    setRet(this.intradayPNL.LO_ML, getRow('LO(ML1)'));
                    setRet(this.intradayPNL.LO_GPREV_FAT, getRow('LO_GERDAU(FATORES)'));
                    setRet(this.intradayPNL.LO_GPREV_ML, getRow('LO_GERDAU(ML1)'));
                    if (ibov && ibov.LastAtt) this.intradayPNL.datetime = ibov.LastAtt;

                }
            });
        },
    },
    created: function () {
        // console.log("created");
        this.loadRetFile();
        // wait(300);
    },
    mounted() {
        // console.log("mounted");
        // console.log(this.preParse);
    },
}
</script>
<style>
.row-toggle {
    cursor: pointer;
}

.toggle-icon {
    padding-left: 0.4em;
}
</style>
  